module.exports = __webpack_public_path__ + "static/MJ-bg-21d9444dc8752cd0d2fd5d435e511f87.png";